import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BASE_URL } from "../Pages/Config";
import "./UserReviewInfo.css";

function StarRating({ smile_count }) {
  let stars = "";
  let lineClass = "";
  let img = "";

  // 1–10 White Line

  if (smile_count >= 0 && smile_count <= 10) {
    stars = "";
    lineClass = "stage1";
    img = "../stars/white.png";
  }

  // 11–20 Silver Line
  else if (smile_count >= 11 && smile_count <= 20) {
    stars = "";
    lineClass = "stage2";
    img = "../stars/silver.png";
  }

  // 21–30 Golden Line
  else if (smile_count >= 21 && smile_count <= 30) {
    stars = "";
    lineClass = "stage3";
    img = "../stars/gold.png";
  }

  // 31–60 White + 1 white star
  else if (smile_count >= 31 && smile_count <= 60) {
    stars = "☆";
    lineClass = "stage1";
    img = "../stars/13.png";
  }

  // 61–90 Silver + 1 silver star
  else if (smile_count >= 61 && smile_count <= 90) {
    stars = "★";
    lineClass = "stage2";
    img = "../stars/12.png";
  }

  // 91–120 Gold + 1 gold star
  else if (smile_count >= 91 && smile_count <= 120) {
    stars = "★";
    lineClass = "stage3";
    img = "../stars/11.png";
  }

  // 121–150 White + 2 white stars
  else if (smile_count >= 121 && smile_count <= 150) {
    stars = "☆☆";
    lineClass = "stage1";
    img = "../stars/21.png";
  }

  // 151–180 Silver + 2 silver stars
  else if (smile_count >= 151 && smile_count <= 180) {
    stars = "★★";
    lineClass = "stage2";
    img = "../stars/22.png";
  }

  // 181–210 Gold + 2 gold stars
  else if (smile_count >= 181 && smile_count <= 210) {
    stars = "★★";
    lineClass = "stage3";
    img = "../stars/24.png";
  }

  // 211–300 White + 3 white stars
  else if (smile_count >= 211 && smile_count <= 300) {
    stars = "☆☆☆";
    lineClass = "stage1";
    img = "../stars/33.png";
  }

  // 301–400 White + 4 white stars
  else if (smile_count >= 301 && smile_count <= 400) {
    stars = "☆☆☆☆";
    lineClass = "stage1";
    img = "../stars/white.png";
  }

  // 1001–1500 Silver + 5 silver stars
  else if (smile_count >= 401 && smile_count <= 500) {
    stars = "★★★★";
    lineClass = "stage2";
    img = "../stars/55.png";
  }

  // 1501–2000 Gold + 6 gold stars
  else if (smile_count >= 501 && smile_count <= 1000) {
    stars = "★★★★";
    lineClass = "stage3";
    img = "../stars/6.png";
  }

  // 2001–2500 White + 7 white stars
  else if (smile_count >= 1001 && smile_count <= 2000) {
    stars = "☆☆☆☆☆";
    lineClass = "stage1";
    img = "../stars/7.png";
  }

  // 2501–3000 Silver + 8 silver stars
  else if (smile_count >= 2001 && smile_count <= 3000) {
    stars = "★★★★★";
    lineClass = "stage2";
    img = "../stars/8.png";
  }

  // 3001–3500 Gold + 9 gold stars
  else if (smile_count >= 3001 && smile_count <= 4000) {
    img = "../stars/9.png";
  }

  // 3501–3800 White + 6 white stars
  else if (smile_count >= 4001 && smile_count <= 5000) {
    stars = "☆☆☆☆☆☆";
    lineClass = "stage1";
    img = "../stars/10.png";
  }

  const starArray = stars.split("");
  const count = starArray.length;

  const size = 45;

  return (
    <div
      style={{
        display: "flex", // ⭐ stays inline with text
        position: "relative",
        width: size,
        height: "auto",
        verticalAlign: "middle",
        alignItems: "end",
      }}
    >
      <div>
        <img src={img} style={{ width: "100%" }} />
      </div>
    </div>
  );
}

const UserReviewInfo = ({ userId }) => {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState({ smiling_percentage: 0 });
  const [smileCount, setSmileCount] = useState({ smile_count: 0 });

  useEffect(() => {
    if (!userId) return;

    let isCancelled = false;

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/get_review.php?id=${userId}&t=${Date.now()}`
        );

        if (res.data.success && !isCancelled) {
          //  console.log(res.data);
          setSmileCount(res.data.rating_stats.smiling_count);
          // setSmileCount(33333);

          //  console.log("Smile Count", res.data.rating_stats.smiling_count);
          setReviews(res.data.reviews || []);
          setRating(res.data.rating_stats || { smiling_percentage: 0 });
        }
      } catch (err) {
        console.error("Error fetching review data:", err);
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [userId]);

  // console.log("smile Count ",smileCount)

  return (
    <div
      style={{
        marginBottom: "10px",
        display: "flex",
        alignItems: "end",
        gap: "5px",
      }}
    >
      <Link to={`/review/${userId}`} style={{ color: "#FAAF3E !important" }}>
        {reviews.length} Review{reviews.length !== 1 ? "s" : ""}
      </Link>{" "}
      <span>{rating.smiling_percentage}%</span>{" "}
      <StarRating smile_count={smileCount} />
    </div>
  );
};

export default UserReviewInfo;
